export const uniqueId = () => Math.random().toString(36).substring(2);
